module.exports = __webpack_public_path__ + "static/media/medial-flexion-up-3.fa18aec6.png";